import React, { useEffect, useRef, useState } from 'react'
import './SecOne.scss'
import Header from './../Header'
import imgOne from './../../assets/Slider/imgOne.png'
import imgTwo from './../../assets/Slider/imgTwo.png'
import imgThree from './../../assets/Slider/imgThree.png'
import bgCircle from './../../assets/LP/bgCircle.svg'
import LogoSpin from './../../assets/LP/LogoSpin.svg'
import LogoSpinTxt from './../../assets/LP/LogoSpinTxt.svg'
import imgBuildingOne from './../../assets/LP/imgBuildingOne.png'
// FOR GSAP
import { TweenMax, TimelineLite, Power3, Power0 } from 'gsap'
// import Aos from "aos";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap'
gsap.registerPlugin(ScrollTrigger)

const SecOne = () => {

  const handleScrollToNext = () => {
   
  };

  const [sliderPosi, setSliderPosi] = useState(1)
  let tl = new TimelineLite({ delay: 0.2 })
  useEffect(() => {
    window.scrollTo(0, 0)
    tl.from(
      '.sectionOneMainTopInnnerLeft h1',
      1.5,
      { y: '120%', ease: Power3.easeOut },
      'Start',
    )
      .from(
        '.sectionOneMainTopInnnerLeft h3',
        1.5,
        { y: '120%', opacity: 0, ease: Power3.easeOut },
        0.8,
      )
      .from(
        '.imgCon',
        1.5,
        { scale: 1.2, opacity: 0, ease: Power3.easeOut },
        0.8,
      )
      .from(
        '.btmImgConS1',
        1.5,
        { scale: 1.2, opacity: 0, ease: Power3.easeOut },
        1.3,
      )
      .from('.tcon h4', 1.5, { x: '-50px', ease: Power3.easeOut }, 1.4)
      .from('.tcon i', 1.5, { y: '-50px', ease: Power0.easeOut }, 1.4)

    gsap.to('.soBl1', {
      duration: 0.5,
      width: '204px',
      delay: 0.5,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soBl2', {
      duration: 0.5,
      width: '208px',
      delay: 1,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soBl3', {
      duration: 0.5,
      width: '203px',
      delay: 1.5,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soBl4', {
      duration: 0.5,
      width: '199px',
      delay: 2,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soB2l1', {
      duration: 0.5,
      width: '274px',
      delay: 1,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soB2l2', {
      duration: 0.5,
      width: '203px',
      delay: 1.5,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soB3l1', {
      duration: 0.5,
      width: '116px',
      delay: 1.2,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soB3l2', {
      duration: 0.5,
      width: '84px',
      delay: 1.7,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.soB3l3', {
      duration: 0.5,
      width: '337px',
      delay: 2.2,
      ease: Power0,
      scrollTrigger: {
        trigger: '.sectionOneMainBotmL',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setSliderPosi(sliderPosi == 3 ? 1 : sliderPosi + 1)
    }, 6000)
    return () => clearInterval(interval)
  }, [sliderPosi])

  return (
    <div className="sectionOneMain">
      <Header active="1" />
      <div className="bgCircleCon">
        <img src={bgCircle} alt="bgCircle" />
      </div>
      <div className="sectionOneMainTop">
        <div className="socialLinks rotate">
          <ul>
            <li>
              <a href="https://www.facebook.com/CognierTechnologyGroup">
                Facebook
              </a>
            </li>
            <div className="circle"></div>
            <li>
              <a href="https://www.linkedin.com/company/cognier-technology/about/">
                Linkedin
              </a>
            </li>
          </ul>
        </div>
        <div className="sectionOneMainTopInnner">
          <div className="keysvg">
            <svg
              width="552"
              height="311"
              viewBox="0 0 552 311"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_5211_16790)">
                <mask
                  id="path-1-outside-1_5211_16790"
                  maskUnits="userSpaceOnUse"
                  x="-51.5007"
                  y="-54.6173"
                  width="607.816"
                  height="358.701"
                  fill="black"
                >
                  <rect
                    fill="white"
                    x="-51.5007"
                    y="-54.6173"
                    width="607.816"
                    height="358.701"
                  />
                  <path d="M494.3 25.199L270.199 94.3315L269.796 93.0237C269.224 91.1688 267.841 89.647 265.953 88.7922C264.064 87.9373 261.823 87.8195 259.722 88.4645L254.744 90.0001C252.644 90.6509 250.859 92.0108 249.78 93.7811C248.701 95.5515 248.416 97.5876 248.989 99.4424L249.392 100.75L230.588 106.551L230.185 105.243C229.903 104.324 229.419 103.477 228.76 102.75C228.101 102.023 227.28 101.431 226.344 101.007C225.409 100.584 224.376 100.337 223.307 100.282C222.237 100.226 221.151 100.363 220.111 100.684L215.133 102.22C213.03 102.868 211.242 104.228 210.16 105.999C209.078 107.771 208.793 109.809 209.365 111.666L209.769 112.974L184.345 120.817L173.054 116.645C171.069 115.909 168.813 115.839 166.673 116.446C164.533 117.054 162.642 118.301 161.325 119.974L156.9 125.6C156.093 126.628 155.063 127.503 153.88 128.167C152.697 128.831 151.388 129.269 150.04 129.451C148.693 129.633 147.338 129.555 146.066 129.223C144.794 128.891 143.634 128.311 142.665 127.524L118.668 108.05C96.0143 88.5592 65.6389 80.8383 36.1081 89.9483C-11.6166 104.671 -36.4557 156.867 -20.4227 208.84C-4.38978 260.812 45.4915 289.97 93.266 275.232C126.953 264.84 149.227 235.738 153.744 201.209C154.725 193.713 156.319 186.253 158.512 178.892C158.869 177.695 159.5 176.564 160.364 175.573C161.228 174.581 162.303 173.754 163.52 173.145C164.736 172.536 166.064 172.16 167.415 172.043C168.767 171.925 170.111 172.068 171.356 172.462L178.178 174.607C180.208 175.251 182.474 175.219 184.585 174.518C186.697 173.816 188.522 172.487 189.748 170.76L196.726 160.953L222.15 153.11L222.554 154.418C222.837 155.337 223.323 156.183 223.983 156.909C224.644 157.635 225.466 158.226 226.402 158.648C227.339 159.07 228.372 159.315 229.441 159.369C230.511 159.423 231.597 159.284 232.637 158.962L237.615 157.426C238.655 157.107 239.63 156.61 240.483 155.962C241.335 155.315 242.05 154.531 242.585 153.655C243.12 152.779 243.465 151.828 243.6 150.856C243.735 149.885 243.658 148.913 243.373 147.995L242.97 146.687L261.774 140.886L262.177 142.194C262.749 144.048 264.131 145.569 266.02 146.422C267.909 147.275 270.149 147.39 272.248 146.743L277.226 145.207C279.325 144.559 281.111 143.202 282.191 141.433C283.271 139.664 283.556 137.629 282.984 135.776L282.581 134.468L388.061 101.928L406.03 160.176C406.171 160.635 406.414 161.058 406.743 161.421C407.073 161.784 407.483 162.079 407.951 162.29C408.419 162.501 408.934 162.624 409.469 162.652C410.003 162.679 410.545 162.611 411.065 162.451L421.021 159.379C422.07 159.056 422.963 158.377 423.503 157.493C424.043 156.608 424.186 155.591 423.9 154.664L419.604 140.739C419.318 139.812 419.461 138.795 420.001 137.91C420.541 137.026 421.434 136.347 422.484 136.023L429.95 133.72C430.47 133.56 430.957 133.311 431.383 132.987C431.809 132.663 432.165 132.271 432.433 131.833C432.7 131.395 432.873 130.92 432.941 130.435C433.009 129.949 432.971 129.463 432.829 129.004L430.538 121.575C430.252 120.648 430.394 119.631 430.934 118.746C431.474 117.862 432.367 117.183 433.417 116.859L457.173 109.531C458.223 109.207 459.343 109.265 460.287 109.691C461.232 110.118 461.923 110.878 462.209 111.805L464.501 119.234C464.642 119.693 464.885 120.116 465.215 120.479C465.544 120.841 465.955 121.137 466.422 121.348C466.89 121.559 467.405 121.682 467.94 121.709C468.474 121.737 469.017 121.669 469.536 121.508L477.003 119.205C477.523 119.043 478.067 118.973 478.602 118.999C479.138 119.026 479.655 119.148 480.124 119.359C480.593 119.57 481.004 119.865 481.335 120.228C481.666 120.592 481.909 121.015 482.051 121.475L486.363 135.455C486.649 136.382 487.341 137.142 488.285 137.568C489.229 137.995 490.349 138.052 491.399 137.729L501.355 134.658C502.404 134.334 503.297 133.655 503.837 132.771C504.377 131.886 504.52 130.869 504.234 129.942L486.265 71.6938L507.669 65.0907C510.662 64.1394 513.457 62.6756 515.895 60.7836C518.333 58.8915 520.366 56.6085 521.876 54.0656C523.387 51.5227 524.345 48.7701 524.696 45.9659C525.048 43.1618 524.785 40.3614 523.923 37.7256C520.259 26.6875 506.832 21.3331 494.3 25.199ZM84.7065 247.265C55.1881 256.371 22.3237 234.794 11.3051 199.076C0.286476 163.358 15.2871 127.027 44.8055 117.921C74.3239 108.815 107.172 130.385 118.191 166.103C129.21 201.821 114.216 238.174 84.7099 247.276L84.7065 247.265Z" />
                </mask>
                <path
                  d="M494.3 25.199L270.199 94.3315L269.796 93.0237C269.224 91.1688 267.841 89.647 265.953 88.7922C264.064 87.9373 261.823 87.8195 259.722 88.4645L254.744 90.0001C252.644 90.6509 250.859 92.0108 249.78 93.7811C248.701 95.5515 248.416 97.5876 248.989 99.4424L249.392 100.75L230.588 106.551L230.185 105.243C229.903 104.324 229.419 103.477 228.76 102.75C228.101 102.023 227.28 101.431 226.344 101.007C225.409 100.584 224.376 100.337 223.307 100.282C222.237 100.226 221.151 100.363 220.111 100.684L215.133 102.22C213.03 102.868 211.242 104.228 210.16 105.999C209.078 107.771 208.793 109.809 209.365 111.666L209.769 112.974L184.345 120.817L173.054 116.645C171.069 115.909 168.813 115.839 166.673 116.446C164.533 117.054 162.642 118.301 161.325 119.974L156.9 125.6C156.093 126.628 155.063 127.503 153.88 128.167C152.697 128.831 151.388 129.269 150.04 129.451C148.693 129.633 147.338 129.555 146.066 129.223C144.794 128.891 143.634 128.311 142.665 127.524L118.668 108.05C96.0143 88.5592 65.6389 80.8383 36.1081 89.9483C-11.6166 104.671 -36.4557 156.867 -20.4227 208.84C-4.38978 260.812 45.4915 289.97 93.266 275.232C126.953 264.84 149.227 235.738 153.744 201.209C154.725 193.713 156.319 186.253 158.512 178.892C158.869 177.695 159.5 176.564 160.364 175.573C161.228 174.581 162.303 173.754 163.52 173.145C164.736 172.536 166.064 172.16 167.415 172.043C168.767 171.925 170.111 172.068 171.356 172.462L178.178 174.607C180.208 175.251 182.474 175.219 184.585 174.518C186.697 173.816 188.522 172.487 189.748 170.76L196.726 160.953L222.15 153.11L222.554 154.418C222.837 155.337 223.323 156.183 223.983 156.909C224.644 157.635 225.466 158.226 226.402 158.648C227.339 159.07 228.372 159.315 229.441 159.369C230.511 159.423 231.597 159.284 232.637 158.962L237.615 157.426C238.655 157.107 239.63 156.61 240.483 155.962C241.335 155.315 242.05 154.531 242.585 153.655C243.12 152.779 243.465 151.828 243.6 150.856C243.735 149.885 243.658 148.913 243.373 147.995L242.97 146.687L261.774 140.886L262.177 142.194C262.749 144.048 264.131 145.569 266.02 146.422C267.909 147.275 270.149 147.39 272.248 146.743L277.226 145.207C279.325 144.559 281.111 143.202 282.191 141.433C283.271 139.664 283.556 137.629 282.984 135.776L282.581 134.468L388.061 101.928L406.03 160.176C406.171 160.635 406.414 161.058 406.743 161.421C407.073 161.784 407.483 162.079 407.951 162.29C408.419 162.501 408.934 162.624 409.469 162.652C410.003 162.679 410.545 162.611 411.065 162.451L421.021 159.379C422.07 159.056 422.963 158.377 423.503 157.493C424.043 156.608 424.186 155.591 423.9 154.664L419.604 140.739C419.318 139.812 419.461 138.795 420.001 137.91C420.541 137.026 421.434 136.347 422.484 136.023L429.95 133.72C430.47 133.56 430.957 133.311 431.383 132.987C431.809 132.663 432.165 132.271 432.433 131.833C432.7 131.395 432.873 130.92 432.941 130.435C433.009 129.949 432.971 129.463 432.829 129.004L430.538 121.575C430.252 120.648 430.394 119.631 430.934 118.746C431.474 117.862 432.367 117.183 433.417 116.859L457.173 109.531C458.223 109.207 459.343 109.265 460.287 109.691C461.232 110.118 461.923 110.878 462.209 111.805L464.501 119.234C464.642 119.693 464.885 120.116 465.215 120.479C465.544 120.841 465.955 121.137 466.422 121.348C466.89 121.559 467.405 121.682 467.94 121.709C468.474 121.737 469.017 121.669 469.536 121.508L477.003 119.205C477.523 119.043 478.067 118.973 478.602 118.999C479.138 119.026 479.655 119.148 480.124 119.359C480.593 119.57 481.004 119.865 481.335 120.228C481.666 120.592 481.909 121.015 482.051 121.475L486.363 135.455C486.649 136.382 487.341 137.142 488.285 137.568C489.229 137.995 490.349 138.052 491.399 137.729L501.355 134.658C502.404 134.334 503.297 133.655 503.837 132.771C504.377 131.886 504.52 130.869 504.234 129.942L486.265 71.6938L507.669 65.0907C510.662 64.1394 513.457 62.6756 515.895 60.7836C518.333 58.8915 520.366 56.6085 521.876 54.0656C523.387 51.5227 524.345 48.7701 524.696 45.9659C525.048 43.1618 524.785 40.3614 523.923 37.7256C520.259 26.6875 506.832 21.3331 494.3 25.199ZM84.7065 247.265C55.1881 256.371 22.3237 234.794 11.3051 199.076C0.286476 163.358 15.2871 127.027 44.8055 117.921C74.3239 108.815 107.172 130.385 118.191 166.103C129.21 201.821 114.216 238.174 84.7099 247.276L84.7065 247.265Z"
                  stroke="url(#paint0_radial_5211_16790)"
                  strokeWidth="4"
                  shape-rendering="crispEdges"
                  mask="url(#path-1-outside-1_5211_16790)"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_5211_16790"
                  x="-52.2812"
                  y="0.953125"
                  width="604.125"
                  height="309.102"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="12.5" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.79 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5211_16790"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5211_16790"
                    result="shape"
                  />
                </filter>
                <radialGradient
                  id="paint0_radial_5211_16790"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(520.477 26.533) rotate(165.543) scale(458.82 174.718)"
                >
                  <stop stopColor="#219EBC" />
                  <stop
                    offset="0.878206"
                    stopColor="#219EBC"
                    stopOpacity="0"
                  />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className="sectionOneMainTopInnnerLeft">
            <div style={{ overflow: 'hidden' }} className="ofhcon">
              <h1>
                Digitalizing <span>Commercial Real Estate Worldwide</span>
              </h1>
            </div>
            <div style={{ overflow: 'hidden' }} className="ofhcon">
              <h3>
                Cognier Technology is the compliance infrastructure for digtal asset and management, rapid transferability of private market securities  providing a complete solution for managing , issuing and transfering of assets
              </h3>
            </div>
          </div>
          <div className="sectionOneMainTopInnnerRight">
            <div
              className={
                'imgCon ' +
                (sliderPosi == 1 && ' one ') +
                (sliderPosi == 2 && ' two ') +
                (sliderPosi == 3 && ' three ')
              }
            >
              {/* mid */}
              <img className="imO oneI" src={imgOne} alt="" />
              <img className="imO twoI" src={imgTwo} alt="" />
              <img className="imO threeI" src={imgThree} alt="" />
              {/* left */}
              <img className="imT oneI" src={imgOne} alt="" />
              <img className="imT twoI" src={imgTwo} alt="" />
              <img className="imT threeI" src={imgThree} alt="" />
              {/* Right */}
              <img className="imTh oneI" src={imgOne} alt="" />
              <img className="imTh twoI" src={imgTwo} alt="" />
              <img className="imTh threeI" src={imgThree} alt="" />
            </div>
            {/* end */}
          </div>
        </div>
        <div className="sectionOneMainTopBTMline">
          <div onClick={handleScrollToNext} style={{ overflow: 'hidden' }} className="tcon">
            <a href="#BenchmarkSection-Main">
            <h4>Scroll </h4>
            </a>
            <i className="fas fa-chevron-down"></i>
          </div>

          <div className="btmImgConS1">
            <img className="LogoSpin" src={LogoSpin} alt="LogoSpin" />
            <img className="LogoSpinTxt" src={LogoSpinTxt} alt="LogoSpinTxt" />
          </div>
        </div>
      </div>
      {/* <div className="sectionOneMainBotm">
        <div data-aos="fade-up" className="sectionOneMainBotmL">
          <div className="animatedImgCon">
            <div className="soBl1"></div>
            <div className="soBl2"></div>
            <div className="soBl3"></div>
            <div className="soBl4"></div>
            <div className="soB2l1"></div>
            <div className="soB2l2"></div>
            <div className="soB3l1"></div>
            <div className="soB3l2"></div>
            <div className="soB3l3"></div>
            <img src={imgBuildingOne} alt="" />
          </div>
        </div>
        <div className="sectionOneMainBotmR">
          <div data-aos="fade-up" className="sectionOneMainBotmRInner">
            <h1>Cognier Technology is ahead in time</h1>
            <h3>
              We aim to maximize growth across all key disciplines of Commercial
              real estate value creation by leveraging innovations in Web3 and
              Blockchain. From smart contracts, and fractional asset
              tokenization to Real Estate NFTs- the Cognier Technology Group is
              ushering in the future of Commercial real estate
            </h3>
            <button
              onClick={() => window.open("Technology", "_self")}
              className="MainGetStartedBTN"
            >
              Get Started{""}
              <i style={{ marginLeft: "10px" }} className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default SecOne
